import { apiGet, apiPatch, apiPost } from "shared/services/apiRequest";

export const getDeviceThermocouplesService = async (deviceId) =>
    (await apiGet(`/thermocouples?deviceId=${deviceId}`))?.data;

export const updateDeviceThermocoupleService = async (deviceId, data) =>
    (await apiPatch(`/thermocouples/${deviceId}`, data))?.data;

export const FaultAttendService = async (attendData) =>
    apiPost("/attends", attendData);

export const getFaultAttendService = async (fault_type, fault_index, device_id) =>
    apiGet(`/attends?fault_type=${fault_type}&fault_index=${fault_index}&device_id=${device_id}`);
